var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 201,
    viewBox: "0 0 161 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_4884)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.516 179.811C25.556 179.811 27.652 178.211 27.652 175.635V175.427H25.748V175.635C25.748 177.283 24.708 178.147 22.532 178.147C20.02 178.147 18.804 176.963 18.804 174.291C18.804 171.619 20.02 170.419 22.532 170.419C24.708 170.419 25.748 171.299 25.748 172.931V173.155H27.652V172.931C27.652 170.371 25.54 168.771 22.516 168.771C19.188 168.771 16.98 170.947 16.98 174.291C16.98 177.635 19.188 179.811 22.516 179.811ZM31.261 179.811C33.069 179.811 34.333 179.011 34.749 177.667H34.861V179.651H36.445V174.819C36.445 172.915 35.309 171.539 32.781 171.539C30.253 171.539 28.749 172.899 28.749 174.707V174.771H30.461V174.707C30.461 173.539 31.181 173.059 32.653 173.059C34.173 173.059 34.749 173.523 34.749 174.835V175.299L31.133 175.683C29.565 175.859 28.573 176.499 28.573 177.731C28.573 179.043 29.613 179.811 31.261 179.811ZM30.301 177.619C30.301 176.995 30.733 176.787 31.629 176.675L34.749 176.323C34.749 177.891 33.533 178.563 31.725 178.563C30.733 178.563 30.301 178.259 30.301 177.619ZM41.7475 179.811C43.9875 179.811 45.4595 178.931 45.4595 177.443C45.4595 176.131 44.5955 175.491 42.7075 175.251L40.8675 174.995C39.6675 174.835 39.3475 174.611 39.3475 173.987C39.3475 173.235 39.8595 172.915 41.3155 172.915C43.0755 172.915 43.5555 173.411 43.5555 174.355V174.451H45.2675V174.403C45.2675 172.515 43.7955 171.539 41.3635 171.539C38.9155 171.539 37.6515 172.531 37.6515 173.923C37.6515 175.251 38.5635 175.891 40.0675 176.083L42.2435 176.371C43.3795 176.531 43.7635 176.739 43.7635 177.395C43.7635 178.099 43.2995 178.419 41.7475 178.419C40.0835 178.419 39.4595 178.083 39.4595 177.043V176.915H37.7315V176.963C37.7315 178.803 39.1875 179.811 41.7475 179.811ZM48.4343 179.651V175.795C48.4343 174.115 49.1063 173.091 50.9943 173.091C52.6423 173.091 53.3623 173.731 53.3623 175.331V179.651H55.0743V174.915C55.0743 172.979 54.0023 171.539 51.8103 171.539C49.7783 171.539 48.8023 172.787 48.5303 174.131H48.4343V168.931H46.7063V179.651H48.4343ZM62.8665 179.811C64.6585 179.811 65.8265 178.947 66.1625 177.363H66.2745V179.651H67.8585V168.931H66.1305V173.859H66.0345C65.7145 172.515 64.6425 171.539 62.7545 171.539C60.3385 171.539 58.9625 173.203 58.9625 175.683C58.9625 178.131 60.3545 179.811 62.8665 179.811ZM60.7065 175.683C60.7065 173.763 61.6985 173.107 63.3625 173.107C65.1385 173.107 66.1305 173.939 66.1305 175.635V175.763C66.1305 177.427 65.0905 178.227 63.3945 178.227C61.6825 178.227 60.7065 177.587 60.7065 175.683ZM73.4563 179.811C75.8243 179.811 77.4883 178.643 77.4883 176.947V176.803H75.7603V176.931C75.7603 177.875 75.0723 178.419 73.4083 178.419C71.5683 178.419 70.8163 177.603 70.7523 176.067H77.5043C77.5523 175.827 77.5683 175.603 77.5683 175.315C77.5683 172.899 75.8883 171.539 73.4243 171.539C70.8323 171.539 69.1363 173.203 69.1363 175.683C69.1363 178.339 70.8483 179.811 73.4563 179.811ZM73.3923 172.899C75.0883 172.899 75.9363 173.603 75.9363 175.075V175.107H70.7682C70.8643 173.683 71.6323 172.899 73.3923 172.899ZM80.5905 182.371V177.411H80.6545C80.9745 178.867 82.1265 179.811 83.9185 179.811C86.3985 179.811 87.7585 178.147 87.7585 175.683C87.7585 173.219 86.3665 171.539 83.9025 171.539C82.0305 171.539 80.9105 172.435 80.5905 173.907H80.4465V171.699H78.8625V182.371H80.5905ZM80.5905 175.811V175.667C80.5905 173.955 81.5825 173.123 83.3585 173.123C85.0225 173.123 86.0305 173.763 86.0305 175.683C86.0305 177.587 85.0385 178.243 83.3265 178.243C81.6305 178.243 80.5905 177.443 80.5905 175.811ZM93.0203 179.811C95.6763 179.811 97.4523 178.131 97.4523 175.683C97.4523 173.203 95.6763 171.539 93.0203 171.539C90.3803 171.539 88.6043 173.203 88.6043 175.683C88.6043 178.131 90.3803 179.811 93.0203 179.811ZM93.0203 178.275C91.1003 178.275 90.3003 177.363 90.3003 175.683C90.3003 173.987 91.1003 173.059 93.0203 173.059C94.9563 173.059 95.7563 173.987 95.7563 175.683C95.7563 177.363 94.9563 178.275 93.0203 178.275ZM102.466 179.811C104.706 179.811 106.178 178.931 106.178 177.443C106.178 176.131 105.314 175.491 103.426 175.251L101.586 174.995C100.386 174.835 100.066 174.611 100.066 173.987C100.066 173.235 100.578 172.915 102.034 172.915C103.794 172.915 104.274 173.411 104.274 174.355V174.451H105.986V174.403C105.986 172.515 104.514 171.539 102.082 171.539C99.6343 171.539 98.3703 172.531 98.3703 173.923C98.3703 175.251 99.2823 175.891 100.786 176.083L102.962 176.371C104.098 176.531 104.482 176.739 104.482 177.395C104.482 178.099 104.018 178.419 102.466 178.419C100.802 178.419 100.178 178.083 100.178 177.043V176.915H98.4503V176.963C98.4503 178.803 99.9062 179.811 102.466 179.811ZM109.153 170.771V168.931H107.425V170.771H109.153ZM109.153 179.651V171.699H107.425V179.651H109.153ZM115.969 179.651V178.099H114.529C113.537 178.099 113.089 177.843 113.089 176.867V173.139H115.969V171.699H113.089V169.955H111.377V171.699H110.033V173.139H111.377V176.963C111.377 178.899 112.433 179.651 114.145 179.651H115.969Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.8237,
    y1: 131.118,
    x2: 28.8237,
    y2: -10.3968,
    stroke: "url(#paint0_linear_75_4884)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.8237,
    y1: 131.118,
    x2: 64.8237,
    y2: -10.3968,
    stroke: "url(#paint1_linear_75_4884)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.824,
    y1: 131.118,
    x2: 100.824,
    y2: -10.3968,
    stroke: "url(#paint2_linear_75_4884)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.824,
    y1: 131.118,
    x2: 135.824,
    y2: -10.3968,
    stroke: "url(#paint3_linear_75_4884)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 29.9794,
    x2: 198.245,
    y2: 29.9793,
    stroke: "url(#paint4_linear_75_4884)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 88.9794,
    x2: 198.245,
    y2: 88.9793,
    stroke: "url(#paint5_linear_75_4884)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 58.9794,
    x2: 198.245,
    y2: 58.9793,
    stroke: "url(#paint6_linear_75_4884)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_75_4884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 44.7755C51.4557 44.7755 50.4542 45.1904 49.7158 45.9288C48.9773 46.6672 48.5625 47.6687 48.5625 48.713C48.5625 49.7573 48.9773 50.7588 49.7158 51.4972C50.4542 52.2357 51.4557 52.6505 52.5 52.6505C53.5443 52.6505 54.5458 52.2357 55.2842 51.4972C56.0227 50.7588 56.4375 49.7573 56.4375 48.713C56.4375 47.6687 56.0227 46.6672 55.2842 45.9288C54.5458 45.1904 53.5443 44.7755 52.5 44.7755Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.125 40.1818C34.125 38.3688 35.595 36.9005 37.4062 36.9005H67.5938C69.405 36.9005 70.875 38.3705 70.875 40.1818V57.2443C70.875 59.0573 69.405 60.5255 67.5938 60.5255H37.4062C36.9754 60.5255 36.5487 60.4406 36.1506 60.2757C35.7525 60.1108 35.3907 59.8692 35.0861 59.5645C34.7814 59.2598 34.5397 58.898 34.3748 58.4999C34.2099 58.1018 34.125 57.6752 34.125 57.2443V40.1818ZM45.9375 48.713C45.9375 46.9725 46.6289 45.3033 47.8596 44.0726C49.0903 42.8419 50.7595 42.1505 52.5 42.1505C54.2405 42.1505 55.9097 42.8419 57.1404 44.0726C58.3711 45.3033 59.0625 46.9725 59.0625 48.713C59.0625 50.4535 58.3711 52.1227 57.1404 53.3534C55.9097 54.5841 54.2405 55.2755 52.5 55.2755C50.7595 55.2755 49.0903 54.5841 47.8596 53.3534C46.6289 52.1227 45.9375 50.4535 45.9375 48.713ZM64.3125 47.4005C63.9644 47.4005 63.6306 47.5388 63.3844 47.7849C63.1383 48.0311 63 48.3649 63 48.713V48.727C63 49.4515 63.588 50.0395 64.3125 50.0395H64.3265C64.6746 50.0395 65.0084 49.9012 65.2546 49.6551C65.5007 49.4089 65.639 49.0751 65.639 48.727V48.713C65.639 48.3649 65.5007 48.0311 65.2546 47.7849C65.0084 47.5388 64.6746 47.4005 64.3265 47.4005H64.3125ZM39.375 48.713C39.375 48.3649 39.5133 48.0311 39.7594 47.7849C40.0056 47.5388 40.3394 47.4005 40.6875 47.4005H40.7015C41.0496 47.4005 41.3834 47.5388 41.6296 47.7849C41.8757 48.0311 42.014 48.3649 42.014 48.713V48.727C42.014 49.0751 41.8757 49.4089 41.6296 49.6551C41.3834 49.9012 41.0496 50.0395 40.7015 50.0395H40.6875C40.3394 50.0395 40.0056 49.9012 39.7594 49.6551C39.5133 49.4089 39.375 49.0751 39.375 48.727V48.713Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4375 63.1505C35.0894 63.1505 34.7556 63.2888 34.5094 63.5349C34.2633 63.7811 34.125 64.1149 34.125 64.463C34.125 64.8111 34.2633 65.1449 34.5094 65.3911C34.7556 65.6372 35.0894 65.7755 35.4375 65.7755C44.8875 65.7755 54.04 67.039 62.7375 69.4068C64.82 69.9738 66.9375 68.4303 66.9375 66.2218V64.463C66.9375 64.1149 66.7992 63.7811 66.5531 63.5349C66.3069 63.2888 65.9731 63.1505 65.625 63.1505H35.4375Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_75_4884)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_4884",
    x1: 29.3237,
    y1: 9.68107,
    x2: 29.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_4884",
    x1: 65.3237,
    y1: 9.68107,
    x2: 65.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_4884",
    x1: 101.324,
    y1: 9.68107,
    x2: 101.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_4884",
    x1: 136.324,
    y1: 9.68107,
    x2: 136.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_4884",
    x1: -60.1421,
    y1: 30.4794,
    x2: 195.012,
    y2: 30.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_4884",
    x1: -60.1421,
    y1: 89.4794,
    x2: 195.012,
    y2: 89.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_4884",
    x1: -60.1421,
    y1: 59.4794,
    x2: 195.012,
    y2: 59.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_4884",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_4884",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_4884"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.f86e46c95532f3357c6724fa996983b1.svg";
export { ForwardRef as ReactComponent };